module.exports = __webpack_public_path__ + "assets/img/3_1379.a91eb367.jpg";